import {
    ApplepayNativeButton,
    ApplepayNativeButtonProps,
} from './ApplepayNativeButton';
import {
    connectApplepayNativeButton,
    ConnectedProps,
} from './connectApplepayNativeButton';

export type ConnectedApplepayNativeButtonProps = Omit<
    ApplepayNativeButtonProps,
    keyof ConnectedProps
>;

export const ConnectedApplepayNativeButton =
    connectApplepayNativeButton(ApplepayNativeButton);
